<template>
  <div>
    <div class="border top">
      <slot name="title"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="border bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: true,
};
</script>

<style scoped lang="scss">
.top {
  margin-bottom: -15px;
}
.border {
  height: 129px;
  background: url(~@this/assets/coupon-border.png) top center/contain no-repeat;
  position: relative;
}
.bottom {
  margin-top: -16px;
  transform: scaleY(-1);
}
.content {
  background: url(~@this/assets/border-bg.png) center/100% auto repeat-y;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.content-title {
  height: 62px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 28px;
}
</style>
